// extracted by mini-css-extract-plugin
export default {"container":"alerts_container__UWWqA","alertTabs":"alerts_alertTabs__YUNg2","tabList":"alerts_tabList__mBBam"};